var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PaymentService from '../../api/PaymentService';
import UpperPaymentService from '../../api/UpperPaymentService';
import _ from 'lodash';
import GlobalVue from "../../globalVue";
import { toDetail, getInvoiceDisplayUrl, isInvoicePdfOrOfd, downloadInvoiceFile } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { mapGetters } from "vuex";
import Edit from './EditOrder.vue';
import CommonService from "../../api/CommonService";
var PaymentOrder = (function (_super) {
    __extends(PaymentOrder, _super);
    function PaymentOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.selectRows = [];
        _this.formData = null;
        _this.swiperShow = false;
        _this.imgs = [];
        _this.getInvoiceDisplayUrl = getInvoiceDisplayUrl;
        _this.placeholder = ['输入客户名称', '输入结算公司', '输入付款单号'];
        _this.statusModalVisbile = false;
        _this.currentRow = {};
        _this.typeList = [
            { name: '全部单据属性', value: null },
            { name: '付款单', value: 1 },
            { name: '预付款单', value: 2 }
        ];
        _this.typeList = [
            { name: '全部单据属性', value: null },
            { name: '付款单', value: 1 },
            { name: '预付款单', value: 2 }
        ];
        _this.orderTypeList = [
            { name: '全部', value: null },
            { name: '供应链', value: 1 },
            { name: '代客下单', value: 4 },
        ];
        _this.statusList = [
            { name: '全部状态', value: null },
            { name: '待确认', value: 1 },
            { name: '已确认', value: 2 },
            { name: '已废弃', value: 5 },
            { name: '部分核销', value: 32 },
            { name: '全部核销', value: 33 },
        ];
        _this.searchTypes = [
            { name: '客户名称', value: 1 },
            { name: '付款单号', value: 3 }
        ];
        _this.payment_type_list = [];
        return _this;
    }
    PaymentOrder.prototype.created = function () {
        this.service = PaymentService.getInstance();
        this.commonService = CommonService.getInstance();
        this.upperPaymentService = UpperPaymentService.getInstance();
        this.initFormData();
        if (this.status) {
            this.formData.order_status = parseInt(this.status.toString());
        }
        ;
        console.log(1111, this.status);
        this.getPaymentList();
        this.getPaymentTypeList();
    };
    PaymentOrder.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 268;
        }, 300);
    };
    PaymentOrder.prototype.statusModalConfirm = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.changeIsTaxTicket({
            order_id: this.currentRow.order_id,
            is_tax_ticket: this.currentRow.is_tax_ticket
        }).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '修改成功');
            _this.statusModalVisbile = false;
            _this.getPaymentList();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PaymentOrder.prototype.changeStatus = function (row) {
        this.currentRow = row;
        this.statusModalVisbile = true;
    };
    PaymentOrder.prototype.initFormData = function () {
        this.formData = {
            is_confirm: null,
            keyword_type: 1,
            keyword: '',
            s_time: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 30),
            e_time: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            payment_type: '',
            order_status: null,
        };
    };
    PaymentOrder.prototype.getPaymentTypeList = function () {
        var _this = this;
        this.upperPaymentService.getPaymentType().then(function (res) {
            var DATA = res.data;
            var payment_type_list = Array.isArray(DATA.data) ? DATA.data : [];
            _this.payment_type_list = [{ value: '', name: '全部' }].concat(payment_type_list);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PaymentOrder.prototype.getPaymentList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var formData = _.cloneDeep(this.formData);
        formData.s_time = formData.s_time && formData.s_time.format('yyyy-MM-dd');
        formData.e_time = formData.e_time && formData.e_time.format('yyyy-MM-dd');
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getPaymentList(Object.assign(formData, pager)).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrder.prototype.previewInvoice = function (item) {
        if (isInvoicePdfOrOfd(item.url)) {
            downloadInvoiceFile(item.url, item.text);
            return;
        }
        window.open(item.url, '_blank');
    };
    PaymentOrder.prototype.toLookImg = function (row) {
        var _this = this;
        this.$refs.carousel.setActiveItem(0);
        this.swiperShow = true;
        this.service.getOrderDocumentList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var order_document = data.data;
                    _this.imgs = Array.isArray(order_document) ? order_document : [];
                }
                else {
                    _this.$message.error("暂无发票图片！");
                }
            }
            else {
                _this.$message.warning('暂无发票图片！');
            }
        }, function (err) { });
    };
    PaymentOrder.prototype.pageChange = function (pager) {
        this.getPaymentList(pager);
    };
    PaymentOrder.prototype.search = function () {
        this.getPaymentList();
    };
    PaymentOrder.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PaymentOrder.prototype.toPaymentDetail = function (order) {
        toDetail(EBillType.Payment, order.order_id, this);
    };
    PaymentOrder.prototype.confirm = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return;
        }
        this.$confirm('确认后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var ids = _.reduce(_this.selectRows, function (ori, newItem) {
                    return ori += ori ? (',' + newItem.order_id) : newItem.order_id;
                }, '');
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.confirmBill({ order_id: ids }).then(function (res) {
                    loadingInstance_1.close();
                    if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getPaymentList();
                    }
                    else {
                        _this.$message.success(res.data.msg);
                        _this.getPaymentList();
                        window._czc.push(["_trackEvent", '付款单列表', '确认付款单']);
                    }
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function (err) {
        });
    };
    PaymentOrder.prototype.discard = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("废弃后将不可修改，是否继续？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            };
            _this.service.discardBill(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.getPaymentList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PaymentOrder.prototype.edit = function (row) {
        GlobalVue.$emit('addTab', {
            component: Edit,
            title: '修改付款单单',
            showExist: true,
            name: 'payment-edit' + row.order_id,
            opener: this,
            cprops: {
                rowId: row.order_id
            }
        });
    };
    PaymentOrder.prototype.getSelectIds = function () {
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PaymentOrder.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = '/supplierclientapi/paymentorder/export_payment_order_detail?order_id=' + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        if (!this.formData.s_time || !this.formData.e_time) {
            this.$message.error("\u8BF7\u9009\u62E9" + (!this.formData.s_time ? '开始' : '结束') + "\u65E5\u671F\uFF01");
            return;
        }
        var formData = _.cloneDeep(this.formData);
        formData.s_time = formData.s_time.format('yyyy-MM-dd');
        formData.e_time = formData.e_time.format('yyyy-MM-dd');
        for (var key in formData) {
            formData[key] = (formData[key] === undefined || formData[key] === null) ? '' : formData[key];
            url = UrlHelper.addParam(url, key, formData[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '付款单列表', '导出付款单']);
    };
    __decorate([
        Prop({
            default: null,
            type: Number || String || null
        })
    ], PaymentOrder.prototype, "status", void 0);
    PaymentOrder = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], PaymentOrder);
    return PaymentOrder;
}(Vue));
export default PaymentOrder;
